<!--服务--> 
<template>
  <div class="servProduc">
    <div class="headImg">
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="containt">
      <div class="tabInfo">
        <!-- <p class="title">{{singleProductInfo.title}}</p> -->
        <p class="title">工程建设和服务</p>
        <div class="article">
          <!--  v-html="singleProductInfo.content" -->
          <div class="serve">
            <swiper :options="caseCenterSwiperOptions">
              <swiper-slide v-for="(item, index) in allProduct" :key="index">
                <div class="case" :style="{'background':'url(http://www.china-tillage.com:8000'+item.pic+')'}">
                  <div class="introduce">
                    <!-- {{item.content}} -->
                    <div class="box" v-html="item.content"></div>
                  </div>
                </div>
                <!-- <p class="title">{{item.title}}</p> -->
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: 'servProduc',
  data() {
    return {
      allProduct: [
        {
          title: "服务",
          cid: 1,
          List:[
            {
              summary: "建筑机电顾问及咨询服务",
              content: "我们拥有一批经验丰富的技术专家和工程技术人员、管理人员和完善的技术服务保障团队，提供从机电系统概念方案、设计、招投标、施工直至竣工验收、项目移交的全过程机电顾问咨询服务。具体的服务系统包括：",
              ulList:[
                "采暖、通风及空调系统",
                "给排水系统",
                "电气系统",
                "弱电/智能化系统",
                "消防系统",
                "高效制冷机房系统"
              ]
            },{
              summary: "建筑机电工程建设服务",
              content: "我们拥有一批经验丰富的技术专家和工程技术人员、管理人员和完善的技术服务保障团队，提供从机电系统概念方案、设计、招投标、施工直至竣工验收、项目移交的全过程机电顾问咨询服务。具体的服务系统包括：",
              ulList:[
                "建筑机电安装工程壹级资质",
                "消防设施工程壹级资质",
                "电子与智能化工程壹级资质",
                "弱电/智能化系统",
                "消防系统",
                "电子与智能化设计乙级资质"
              ]
            },{
              summary: "智慧运维托管服务",
              content: "我们为客户提供设施运维管理的托管服务，通过先进的物联网技术及大数据，实现运维信息的采集、处理、记录及远程实时监控，帮助管理者全面掌握设备运行情况，通过标准的运维服务流程，转变传统被动响应的运维方式，建立面向用户的集中、主动的智慧运维管理模式。",
              ulList:[]
            },{
              summary: "中央空调能效监测及评估服务",
              content: "我们为客户提供中央空调冷热源站的精准数据监测产品和服务，是中国建筑节能减排产业联盟授权的“蓝天杯”高效机房（能源站）评选活动在西南区的唯一指定技术服务商，我们通过精准的数据采集，根据国家规范和标准，为客户提供能效诊断、运维状况诊断、设备健康诊断等，并为客户提供可靠分析报告，提供节能或管理的调整或改造建议。",
              ulList:[]
            },{
              summary: "能源审计服务",
              content: "我们为客户提供能源管理系统在线监测和分析产品，同时通过自动采集所需的能源数据，为客户提供能源效率评价和能源管理改进建议等审计服务，服务内容包括能源使用情况分析、主要耗能设备能效分析、能源管理措施优化，降低能源成本措施和节能改造建议等。为客户统筹管理电、水、气、冷、热等多种能源，提升能源管理的效率和体验，挖掘节能潜力，达到优化管理、节能降耗的目标",
              ulList:[]
            },{
              summary: "节能改造服务",
              content: "我们根据建筑机电设施的运行和能耗数据分析，找到设施最佳运行模式和节能之间的平衡点，分析节能潜力，制定节能措施，提供切实可行的节能改造方案和实施服务，并提供能耗监测和耗能设备优化、节能控制系统、能效监测系统，以及智慧管理等服务，确保节能目标的实现。",
              ulList:[]
            },{
              summary: "合同能源管理服务",
              content: "合同能源管理（EPC——Energy Performance Contracting）：我们与愿意进行节能改造的用户签订节能服务合同，为用户的节能项目提供包括节能诊断、融资、节能项目设计、原材料和设备采购、施工、调试、监测、培训、运行管理等的特色性服务，通过节能项目实施后产生的节能效益来赢利和滚动发展。目前主要有以下几种服务模式：",
              ulList:[
                "1.节能效益分享:在项目期内用户和我们双方分享节能效益的合同类型。节能改造工程的投入按照我们与用户的约定共同承担或由我们单独承担。项目建设施工完成后，经双方共同确认节能量后，双方按合同约定比例分享节能效益。项目合同结束后，节能设备所有权无偿移交给用户，以后所产生的节能收益全归用户。节能效益分享型是我国政府大力支持的模式类型。",
                "2.能源费用托管:用户委托我们出资进行能源系统的节能改造和运行管理，并按照双方约定将该能源系统交我们管理，由我们对外缴纳能源费用，用户的能源费用按约定单价和实际使用量由用户支付给我们的合同类型。项目合同结束后，我们改造的节能设备无偿移交给用户使用，以后所产生的节能收益全归用户。",
                "3.节能量保证:用户投资，我们向用户提供节能服务并承诺保证项目节能效益的合同类型。项目实施完毕，经双方确认达到承诺的节能效益，用户一次性或分次向我们支付服务费，如达不到承诺的节能效益，差额部分由我们承担。",
                "4.融资租赁:由第三方融资公司投资购买我们的节能设备和服务，并租赁给用户使用，根据协议定期向用户收取租赁费用。我们负责对用户的能源系统进行改造，并在合同期内对节能量进行测量验证，担保节能效果。项目合同结束后，节能设备由融资公司无偿移交给用户使用，以后所产生的节能收益全归用户。",
                "5.混合型:由以上4种基本类型的任意组合形成的合同类型。"
              ]
            },{
              summary: "钢结构工程建设服务",
              content: "我们有丰富的钢结构工程施工管理能力和经验，按照GB国标及钢结构规范要求建立了完善的质量保证体系。我公司结合BIM技术，可完成各类复杂的钢结构项目，为客户提供优质的服务。",
              ulList:[]
            },{
              summary: "软件定制开发服务",
              content: "我们除为客户提供标准的智慧管理类软件产品外，更可根据客户的需求，在自有软件产品的基础上，为客户量身定制一系列符合客户实际应用的软件，满足客户的需求，提供让客户满意的服务",
              ulList:[]
            }
          ]
        },
        {
          title: "产品",
          cid: 2,
          List:[
            {
              summary: "智慧机电大数据平台",
              content: `采用开放式软硬件技术平台，将建筑内各种开放或私有的机电子系统，如暖通空调、能源管理、电梯、门禁、给排水、变配电、照明、视频、安防、消防等系统集成到一个统一的信息化平台中，构造一个建筑物的空间、设备、能源、环境的数据化、可视化管理和控制平台，通过数据互联、融合对各类机电设备的健康检测、风险预警、联动控制、事件管理进行二次赋能，实现从单设备、单场景的智能化走向整体化、全局化、科学化的管理与控制，从而帮助管理部门、业主、运维团队实现自动化、同步化的控制与管理，达到节约能源、节约人力、提高管理效率、提高设备使用寿命以及创造舒适的、智慧化的建筑物的目的。
                        通过持续累积不同使用目的建筑物的机电运行数据、使用数据、交互数据，形成庞大的数据仓库，通过大数据挖掘技术、人工智能深度学习技术，深入分析机电系统运行的内在数据关联和人机交互实质，找出这些机电系统间横向的数据交换语言与最优的数据交换逻辑以及可靠的控制关系，进而实现全机电系统间的实时数据共享与控制信息互联互通，找到真正的“机器语言”、“运行逻辑”、“控制关系”、“交互习惯”，进而给出各类建筑物最优的机电配置、能源消耗、维护保养、运行方式、人机交互标准，实现全社会机电系统的智慧管理与运营，最终实现全社会资源的最优化运行、精细化管理、节能减排以及智慧化服务。`,
              ulList:[]
            },{
              summary: "智慧楼宇集约化管理系统(T-IBMS)",
              content: "采用开放式软硬件技术平台，将建筑内各种开放或私有的机电子系统，如暖通空调、能源管理、电梯、门禁、给排水、变配电、照明、视频、安防、消防等系统集成到一个统一的信息化平台中，构造一个建筑物的空间、设备、能源、环境的数据化、可视化管理和控制平台，通过数据互联、融合对各类机电设备的健康检测、风险预警、联动控制、事件管理进行二次赋能，实现从单设备、单场景的智能化走向整体化、全局化、科学化的管理与控制，从而帮助管理部门、业主、运维团队实现自动化、同步化的控制与管理，达到节约能源、节约人力、提高管理效率、提高设备使用寿命以及创造舒适的、智慧化的建筑物的目的。",
              ulList:[
                "①采暖、通风及空调系统",
                "②给排水系统",
                "③电气系统",
                "④弱电/智能化系统",
                "⑤消防系统",
                "⑥高效制冷机房系统"
              ]
            }
          ]
        },{
          title: "解决方案",
          cid: 3,
          List:[
            {
              summary: "智慧写字楼",
              content: "解决方案涵盖智慧停车管理、智慧人行管理、智慧访客管理、智慧会议室管理等多种智慧终端设备，以云平台连接楼宇、连接用户，围绕智能办公位核心，提供停车无人化、人员通行一脸通、访客在线预约、会议室线上预订等服务，让办公硬件配置可远程管控，数据实现可视化，畅享写字楼新体验。",
              ulList:[]
            },{
              summary: "2.智慧商业",
              content: "一般大型商超建筑的体量较大，管理和维护难度大，解决方案以信息技术为支撑，创新商业管理手段，融合互联网技术、云计算及大数据、物联网+AI等技术，为客户提供客流统计、停车管理、运维管理、智能化交互技术，提升顾客购物体验，为管理者提供多维度的数据分析报告，实现精细化、可视化运营、降低管理成本，提供招商引资分析，为商业营运赋能。",
              ulList:[]
            }
          ]
        }
      ],
      singleProductInfo:[],
      headImg: "",
      baseURL: null,
      caseCenterSwiperOptions: {
        // 参数选项,显示小点
        pagination: {
          el: '.swiper-pagination',
        },
        //循环
        loop: false,
        slidesPerView: 3,
        spaceBetween: 30,
        //每张播放时长3秒，自动播放
        autoplay:2000,
        //滑动速度
        speed: 200,
      },
    }
  },
  components: {},
  mounted() {
    this.baseURL = baseURL
    this.getheadImg()
    this.getProduct()
    this.singleProductInfo = this.allProduct[0]
  },
  methods: {
    // 获取顶部大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/message`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    getProduct(){
      this.$http.get(`${baseURL}/json/message?page=1&rows=1000`).then( (res)=>{
          console.log(res,"服务")
          this.allProduct = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
  },
}
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.servProduc{
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .containt{
    width: 1200px;
    padding: 50px 0%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .tabInfo{
      width: 100%;
      padding: 0 0 50px 0;
      p.title{
        font-size: 40px;
        padding: 0 0 30px 0;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: center;
        color: #07142b;
        line-height: 40px;
        text-shadow: 0px 2px 5px 0px rgba(6,30,58,0.28);
      }
      .img{
        width: 650px;
        height: 490px;
        // background: #1b2245;
        border-radius: 4px;
        margin: 0 auto;
      }
      p.subTitle{
        padding: 10px 0 20px 0;
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        // color: #07142b;
        color: #fff;
        line-height: 33px;
      }
      .article{
        width: 100%;
        height: 520px;
        // padding: 10px 0;
        // font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: justify;
        // color: #fff;
        line-height: 24px;
        letter-spacing: 1px;
        text-indent: 2rem;
        .serve{
          height: 500px;
          padding: 20px 0;
          .case{
            width: 380px;
            height: 500px;
            position: relative;
            cursor: pointer;
            // border: 1px solid blue;
            .introduce{
              width: 360px;
              height: 480px;
              padding: 10px;
              background-color: rgb(52,136,234,0.5);
              position: absolute;
              top: 500px;
              transition: top 0.2s ease-out;
              text-align: left;
              color: #fff;
              display:flex;
              align-items: center;
              .box{
                width: 100%;
              }
            }
          }
          .case:hover .introduce{
            top: 0px;
          }
          .swiper-pagination-bullets{
            position: relative;
            top: 50px;
            .swiper-pagination-bullet{
              margin: 0 10px;
              // border: 1px solid #818599;
              border-radius: 50%;
            }
          }
        }
        p{
          text-indent: 2rem;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>